import { render, staticRenderFns } from "./Qnainquiry.vue?vue&type=template&id=52902ce0&scoped=true&"
import script from "./Qnainquiry.vue?vue&type=script&lang=js&"
export * from "./Qnainquiry.vue?vue&type=script&lang=js&"
import style0 from "./Qnainquiry.vue?vue&type=style&index=0&id=52902ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52902ce0",
  null
  
)

export default component.exports